import { render } from "./eventsTab.vue?vue&type=template&id=78cf1c06&scoped=true"
import script from "./eventsTab.vue?vue&type=script&lang=ts"
export * from "./eventsTab.vue?vue&type=script&lang=ts"

import "./eventsTab.vue?vue&type=style&index=0&id=78cf1c06&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78cf1c06"

export default script